import { ApiErrorDiagnostics } from '~/Interfaces';
import { RootState } from '..';

// Error UI can open without an HTTP error behind it (local rejections, zod parse
// failures, UI-driven triggers), so display is bounded in time to avoid stale IDs.
const DIAGNOSTICS_TTL_MS = 30_000;

export const selectFreshApiErrorDiagnostics = (
  state: RootState
): ApiErrorDiagnostics | undefined => {
  const diagnostics = state.globalError.apiErrorDiagnostics;

  if (!diagnostics) {
    return undefined;
  }

  const isFresh = Date.now() - diagnostics.capturedAt <= DIAGNOSTICS_TTL_MS;

  return isFresh ? diagnostics : undefined;
};
